<template>
  <div class="soundSet-pane" @keydown.stop>
    <div class="tabTitle">
      <p>配音设置</p>
    </div>
    <!-- <template v-if="smartVoiceData">
      <div style="height: calc(100% - 46px)">
        <smartVoiceSet
          ref="smartVoiceSet"
          style="height: 100%"
          :smartVoiceData="smartVoiceData"
          @remove="confirmDel"
        ></smartVoiceSet>
      </div>
    </template> -->
    <template>
      <div class="soundtrack-container" v-if="getSelectDubbing && !isSmart">
        <div v-if="isRoleExpired" class="warning">音色已下架，无法修改编辑</div>
        <div class="soundtrack-item">
          <div class="soundtrack-item-name">
            <p>{{ getSelectDubbing.title }}</p>
          </div>
          <div class="soundtrack-operate">
            <div class="play-shell">
              <div
                class="play-btn"
                :class="[dobing.isPlay ? 'play-btn-pause' : 'play-btn-play']"
                @click="musicPlaySet"
              ></div>
            </div>
            <div class="soundtrack-bar" style="height: 100%">
              <audio
                ref="audioDubSet"
                :src="$handleAssetsUrl(getSelectDubbing.url)"
                @loadedmetadata="getAudioLengthSet"
                @timeupdate="audioTimeUpdateSet"
                @play="handPlaySet"
                @pause="handPauseSet"
                controls="controls"
                :volume="getDubbingVolume"
                style="display: none"
              ></audio>
              <div>
                <el-slider
                  :show-tooltip="false"
                  v-model="dobing.currentTime"
                  :max="dobing.duration"
                  @change="changeAudioTimeSet"
                ></el-slider>
              </div>
            </div>
            <div class="soundtrack-times">
              <!-- musicTimeConverter(dobing.currentTime) +
                " / " + -->
              <span class="music-time-msg">{{
                formatTime(dobing.duration)
              }}</span>
            </div>
          </div>
        </div>
        <div class="soundtrack-btn">
          <div class="soundtrack-btn-2">
            <el-button
              size="small"
              @click="replaceMusic(getSelectDubbing, 'dub', getDubbingIndex)"
              class="replace-btn"
              >替换</el-button
            >
            <el-button size="small" class="clip-btn" @click="showClip"
              >剪辑</el-button
            >
          </div>
          <div>
            <el-button
              size="small"
              @click="confirmDel()"
              class="soundtrack-delete"
              >删除</el-button
            >
          </div>
        </div>
      </div>
      <div v-else-if="(smartVoiceData || getSelectDubbing) && isSmart" style="height: calc(100% - 46px)">
        <smartVoiceSet
          ref="smartVoiceSet"
          style="height: 100%"
          :smartVoiceData="smartVoiceData"
          @remove="confirmDel"
        ></smartVoiceSet>
      </div>
    </template>
    <div v-show="!getSelectDubbing" style="height: 100%; position: relative">
      <p class="noMUsic">未选中任何元素</p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import audioPlay from "@/components/emodal/templateLib/contents/audioPlay.vue";
import smartVoiceSet from "./smartVoiceSet.vue";
export default {
  mixins: [audioPlay],
  components: {
    smartVoiceSet,
  },
  data() {
    return {
      dobing: {
        isPlay: false,
        duration: 0, //标记时间戳
        currentTime: 0, //当前播放时间
      },
      isSmart: false,
      isRoleExpired: false,
      smartVoiceData: null
    };
  },
  computed: {
    ...mapGetters({
      getSelectDubbing: "addSoundtrack/getSelectDubbing",
      getDubbingIndex: "addSoundtrack/getDubbingIndex",
      getDubbingVolume: "addSoundtrack/getDubbingVolume",
      dubbingArr: 'addSoundtrack/getDubbingArr',
    }),
  },
  created() {
    this.$watch(
      () => this.getSelectDubbing && this.getSelectDubbing.url,
      () => {
        this.isRoleExpired = false;
        this.fetchSmartVoice(this.getSelectDubbing);
      }
    );
  },
  mounted() {
    this.isSmart = false;
    this.isRoleExpired = false;

    this.$bus.on("replace_current_dubing", (state) => {
      this.dobing.currentTime = 0;
      this.getAudioLengthSet();
    });
    // this.updateIsSmart();
    this.fetchSmartVoice(this.getSelectDubbing);
  },
  watch: {
    "dobing.currentTime": {
      handler: function (val) {
        if (val == this.dobing.duration) {
          this.dobing.currentTime = 0;
          this.$refs.audioDubSet.pause();
          this.$refs.audioDubSet.currentTime = this.getSelectDubbing.cut[0];
        }
      },
    },
    getSelectDubbing(val) {
      if (val) {
        this.dobing = {
          isPlay: false,
          duration: 0, //标记时间戳
          currentTime: 0, //当前播放时间
        };
        if (this.$refs.audioDubSet) {
          this.remarkAudioDub();
        }

        // this.fetchSmartVoice(val);
      }
    }
  },
  beforeDestroy() {},
  methods: {
    ...mapActions({
      checkSmart: "smartVoice/isSmart",
      isRoleExisted: 'smartVoice/isRoleExisted'
    }),
    async fetchSmartVoice(dubbing) {
      // if (this.isRoleExpired) return;
      if (!dubbing) return;
      const soundUrl = dubbing.url || '';
      const url = soundUrl.replace(/\.mp3$/, '.json');
      let resp = null;
      try {
        resp = await fetch(this.$handleAssetsUrl(url));
        resp = await resp.json();
      } catch (e) {
        resp = null;
      }
      console.log(`Turbo ~ fetchSmartVoice ~ resp`, resp);
      this.smartVoiceData = resp || null;

      this.updateIsSmart();
    },
    remarkAudioDub() {
      //重启当前配音
      this.getAudioLengthSet();
      this.$refs.audioDubSet.pause();
      this.$refs.audioDubSet.currentTime = this.getSelectDubbing.cut[0];
    },
    async updateIsSmart() {
      let isSmart = await this.checkSmart(this.getSelectDubbing || {});
      this.isSmart = isSmart;

      const {existed, expired} = await this.isRoleExisted(this.smartVoiceData || this.getSelectDubbing || {});
      this.isRoleExpired = false;
      
      if (existed) {
        this.isSmart = true;
        this.isRoleExpired = false;
        if (expired) {
          this.isSmart = false;
          this.isRoleExpired = true;
        }
      } else {
        this.isSmart = false;
        this.isRoleExpired = false;
      }

      if (this.isSmart) {
        this.$refs.smartVoiceSet && this.$refs.smartVoiceSet.getReaders();
      }
    },
    changeAudioTimeSet(val) {
      if (this.$refs.audioDubSet) {
        this.$refs.audioDubSet.currentTime = val + this.getSelectDubbing.cut[0];
      }
    },
    getAudioLengthSet() {
      if (this.getSelectDubbing) {
        this.dobing.duration =
          this.getSelectDubbing.cut[1] - this.getSelectDubbing.cut[0];
      }
    },
    handPlaySet: function () {
      this.dobing.isPlay = true;
      this.$refs.audioDubSet.currentTime =
        this.dobing.currentTime + this.getSelectDubbing.cut[0];
    },
    handPauseSet: function () {
      this.dobing.isPlay = false;
      if (this.$refs.audioDubSet.ended) {
        this.dobing.currentTime = 0;
      }
    },
    musicPlaySet: function () {
      if (!this.dobing.isPlay) {
        this.$refs.audioDubSet.play();
      } else {
        this.$refs.audioDubSet.pause();
      }
    },
    audioTimeUpdateSet() {
      let time = this.$refs.audioDubSet.currentTime;
      if (time - this.dobing.currentTime > 1) {
        this.dobing.currentTime =
          parseFloat(time) - parseFloat(this.getSelectDubbing.cut[0]);
      }
    },
    confirmDel() {
      this.$modal.show("SubtitleMessageDialog", {
        view: "Common",
        msg: "确认要删除该配音文案吗?",
        resultCallback: (value) => {
          if (value && value.type == "Ok") {
            this.deleteSoundtrack();
          }
        },
      });
    },
    // 删除选中的配音
    deleteSoundtrack() {
      this.$refs.audioDubSet && this.$refs.audioDubSet.pause();
      let data = {
        index: this.getDubbingIndex,
        data: JSON.stringify(
          Object.assign({}, this.getSelectDubbing, {
            load: false,
            ele: null,
            playing: false,
          })
        ),
      };
      this.$store.commit("addSoundtrack/delDubbing", this.getDubbingIndex);
      this.$bus.emit("insert_subtitle_undo", {
        type: "delDubbing",
        data: data,
      });
    },
    showClip() {
      this.$refs.audioDubSet.pause();
      if (parseInt(this.$refs.audioDubSet.duration) <= 1) {
        return this.$message("视频时长小于两秒不支持剪辑");
      }
      this.$store.commit("soundtrackSet/setsoundtrackClipState", true);
      this.$store.commit("soundtrackSet/setCutMusic", this.getSelectDubbing);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../soundtrack/common.scss";
.warning {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 226px;
  height: 28px;
  background: #FFF0E0;
  opacity: 1;
  border-radius: 4px;
  font-size: 12px;
  color: #FA8C16;
  margin-top: -10px;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/dubbing/dubSet.vue